import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from '@mui/material'
import { FilterList, Clear } from '@mui/icons-material'

const LINE_OPTIONS = ['1', '2', '3', '4']
const ABC_OPTIONS = ['A', 'B', 'C']
const ISSUE_OPTIONS = [
  { value: 'issues', label: 'Has Issues' },
  { value: 'clear', label: 'Clear' },
]
const AUTO_INV_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
]

export default function FilterBar({ filters, onFilterChange, briteCodeOptions = [] }) {
  const activeCount = Object.values(filters).filter((v) => v !== '' && v != null).length

  const handleChange = (field) => (e) => {
    onFilterChange({ ...filters, [field]: e.target.value })
  }

  const clearAll = () => {
    onFilterChange({ line: '', briteCode: '', abcClass: '', issueStatus: '', autoInv: '' })
  }

  const selectSx = {
    minWidth: 100,
    '& .MuiSelect-select': { py: 0.75, fontSize: '0.8125rem' },
    '& .MuiInputLabel-root': { fontSize: '0.8125rem' },
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
      <FilterList sx={{ fontSize: 18, color: 'text.secondary' }} />

      <FormControl size="small" sx={selectSx}>
        <InputLabel>Line</InputLabel>
        <Select value={filters.line} label="Line" onChange={handleChange('line')}>
          <MenuItem value="">All</MenuItem>
          {LINE_OPTIONS.map((l) => (
            <MenuItem key={l} value={l}>{l}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={selectSx}>
        <InputLabel>Brite Code</InputLabel>
        <Select value={filters.briteCode} label="Brite Code" onChange={handleChange('briteCode')}>
          <MenuItem value="">All</MenuItem>
          {briteCodeOptions.map((b) => (
            <MenuItem key={b} value={b}>{b}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={selectSx}>
        <InputLabel>ABC Class</InputLabel>
        <Select value={filters.abcClass} label="ABC Class" onChange={handleChange('abcClass')}>
          <MenuItem value="">All</MenuItem>
          {ABC_OPTIONS.map((c) => (
            <MenuItem key={c} value={c}>{c}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={selectSx}>
        <InputLabel>Issues</InputLabel>
        <Select value={filters.issueStatus} label="Issues" onChange={handleChange('issueStatus')}>
          <MenuItem value="">All</MenuItem>
          {ISSUE_OPTIONS.map((o) => (
            <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={selectSx}>
        <InputLabel>Auto-Inv</InputLabel>
        <Select value={filters.autoInv} label="Auto-Inv" onChange={handleChange('autoInv')}>
          <MenuItem value="">All</MenuItem>
          {AUTO_INV_OPTIONS.map((o) => (
            <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      {activeCount > 0 && (
        <Chip
          icon={<Clear sx={{ fontSize: 14 }} />}
          label={`Clear (${activeCount})`}
          size="small"
          onClick={clearAll}
          sx={{ fontSize: '0.75rem' }}
        />
      )}
    </Box>
  )
}
